const Navbar = () => {
return ( 
    <nav className="navbar">
    <h1>J.</h1>
    <div className="links">
    
    <a  href="" style={{
        color:'#0b0b0b',
        border:'2px solid #0b0b0b',
        borderRadius:'5px'
        
    }}>Contact Me</a>
    </div>
</nav>
 );
}
 
export default Navbar;